import * as tslib_1 from "tslib";
import { orchestrator } from 'satcheljs';
import setIsRemovingDomain from '../mutators/setIsRemovingDomain';
import { deleteDomain } from '../services/deleteDomain';
import { getDomainState } from '../actions/getDomainState';
import { removeDomain } from '../actions/removeDomain';
import { traceRemoveDomainButtonClick } from '../utils/domainOptionTracer';
export default orchestrator(removeDomain, function removeDomain() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    traceRemoveDomainButtonClick();
                    setIsRemovingDomain(true);
                    return [4 /*yield*/, deleteDomain()];
                case 1:
                    _a.sent();
                    setIsRemovingDomain(false);
                    return [4 /*yield*/, getDomainState()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=removeDomain.js.map